<div fxLayout="column" class="campaigns-wrapper">
 
  <div>
    <mat-toolbar fxFlex fxLayout="row">
      <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutAlign="start start" [class.compact-header-text]="media.isActive('lt-sm')">
        <span id="id_record_cnt_lbl" class="mat-body-1 padding-right-5">
          {{ 'LABEL_RECORD_COUNT' | translate }}
        </span>
        <span class="mat-body-1">
          {{ listLength }}
        </span>
      </div>
 
      <div fxFlex fxLayout fxLayoutAlign="end center">
        <!-- Search Bar -->
        <form 
          novalidate           
          autocorrect="off"
          [formGroup]="form"           
          autocomplete="off"
          >

          <mat-form-field 
            floatLabel="never" 
            class="max-width-160"
            [style.font-size.px]="media.isActive('lt-sm') ? '12' : '14'"
            >

            <input 
              id="id_search_txtbox"
              matInput 
              #searchTerm
              formControlName="searchTerm"
              [placeholder]="'LABEL_SEARCH' | translate"
              >

            <mat-icon 
              matSuffix
              color="primary"
              class="clear-input"
              svgIcon="close-circle"
              *ngIf="searchTerm.value"
              [matTooltip]="'LABEL_CLEAR' | translate"
              (click)="form.get('searchTerm').setValue('')"
              >
            </mat-icon>
          </mat-form-field>
        </form>

        <button id="id_refresh_btn" mat-icon-button [matTooltip]="'LABEL_REFRESH' | translate" [disabled]="loading.init || loading.more" (click)="refresh()">
          <mat-icon svgIcon="refresh"></mat-icon>
        </button>
 
        <button id="id_filter_btn" [class.filter-color]="filterNumber > 0" mat-icon-button [matTooltip]="'LABEL_FILTER' | translate" [disabled]="loading.init || loading.more" (click)="openFilter()">
          <mat-icon svgIcon="filter-variant"></mat-icon>
        </button>
 
        <button 
          *ngIf="authService.hasPermission('CW' + constants.PERMISSION_STRINGS.add)" 
          id="id_add_btn" 
          [class.filter-color]="filterNumber > 0" 
          mat-icon-button [matTooltip]="'LABEL_ADD_NEW' | translate: { type: 'Campaign' }" 
          [disabled]="loading.init || loading.more" 
          (click)="openWizard(null, 'add', null)"
          >
          <mat-icon svgIcon="plus"></mat-icon>
        </button>
      </div>
    </mat-toolbar>
  </div>
 
  <div fxLayout="column" infiniteScroll (scrolled)="getMoreData()" [scrollWindow]="false" class="report-table-wrapper" *ngIf="!loading.init && listData?.length" [class.empty-report]="!listData?.length" fxFlex>
    <div>
      <table mat-table [dataSource]="listData">

        <!-- Actions -->
        <ng-container matColumnDef="actions" sticky>
          <th id="id_actions_header" mat-header-cell *matHeaderCellDef>Actions</th>
          <td mat-cell *matCellDef="let element; let i = index">
            
            <div fxLayout fxLayoutAlign="space-evenly center">

              <button [id]="'id_edit_btn_' + (i+1)" 
              [disabled]="
                element?.distribution_is_active == 0 || 
                !authService.hasPermission('CW' + constants.PERMISSION_STRINGS.update) ||
                element.status == 'Completed'
              " 
              mat-icon-button [matTooltip]="'LABEL_EDIT' | translate" (click)="openWizard($event, 'edit', element)">
                <mat-icon svgIcon="pencil"></mat-icon>
              </button>

              <!-- <button [id]="'id_view_btn_' + (i+1)" *ngIf="element.status == 'Completed'" mat-icon-button matTooltip="View" (click)="openWizard('view', element)">
                <mat-icon svgIcon="eye"></mat-icon>
              </button> -->
 
              <button 
                [id]="'id_gen_btn_' + (i+1)"
                mat-icon-button 
                [matTooltip]="'LABEL_GENERATE_COUPON' | translate" 
                (click)="generateCoupon($event, element)" 
                [disabled]="element?.distribution_is_active == 0 || (authService.hasPermission('CW' + constants.PERMISSION_STRINGS.update) ||
                ((element?.pre_generated_qty/element?.pre_generated_max_qty == 1) && (element?.on_demand_qty/element?.on_demand_max_qty == 1 || (element?.on_demand_qty == 0 && element?.on_demand_max_qty == 0) )) || 
                (element.status == 'Completed' || !element.condition_id) || (element?.distribution_is_active == 0))
                ">
                <mat-icon svgIcon="ticket-percent"></mat-icon>
              </button>

              <button 
                [id]="'id_dl_btn_' + (i+1)"
                mat-icon-button 
                [matTooltip]="'LABEL_DOWNLOAD_COUPONS' | translate" 
                (click)="downloadCouponsList($event, element)"
                *ngIf="authService.hasPermission('CW' + constants.PERMISSION_STRINGS.update)"
                [disabled]="element?.distribution_is_active == 0 || element?.status.toLowerCase() != 'ongoing'">
                <mat-icon svgIcon="download"></mat-icon>
              </button>

              <button 
                [id]="'id_del_btn_' + (i+1)"
                mat-icon-button 
                [matTooltip]="'LABEL_DELETE' | translate" 
                (click)="deleteCampaign($event, element)"
                *ngIf="authService.hasPermission('CW' + constants.PERMISSION_STRINGS.update)"
                [disabled]="element?.distribution_is_active == 0 || element?.status.toLowerCase() != 'pending'">
                <mat-icon svgIcon="delete"></mat-icon>
              </button>
            </div>
          </td>
        </ng-container>
 
        <!-- Campaign Name -->
        <ng-container matColumnDef="campaign_name">
          <th id="id_campaign_header" mat-header-cell *matHeaderCellDef>{{'TBL_HDR_CAMPAIGN' | translate}}</th>
          <td [id]="'id_campaign_data_' + (i+1)" mat-cell *matCellDef="let element; let i = index"> 
            {{element?.campaign_code}} - {{element?.campaign_description}}
          </td>
        </ng-container>
 
        <!-- Distribution Name -->
        <ng-container matColumnDef="distribution_name">
          <th id="id_dist_header" mat-header-cell *matHeaderCellDef>{{'TBL_HDR_DISTRIBUTION' | translate}}</th>
          <td [id]="'id_dist_data_' + (i+1)" mat-cell *matCellDef="let element; let i = index"> 
            {{element?.distribution_code}} - {{element?.distribution_description}}
          </td>
        </ng-container>
 
        <!-- Status -->
        <ng-container matColumnDef="status">
          <th id="id_status_header" mat-header-cell *matHeaderCellDef>{{'TBL_HDR_STATUS' | translate}}</th>
          <td [id]="'id_status_data_' + (i+1)" mat-cell *matCellDef="let element; let i = index">
            {{ element?.distribution_is_active == 0 ? 'Deleting' : element?.status }}
          </td>
        </ng-container>
 
        <!-- Pre-Generated Quantity -->
        <ng-container matColumnDef="pre_generated">
          <th id="id_pre_gen_header" mat-header-cell *matHeaderCellDef [innerHtml]="'TBL_HDR_PRE_GENERATED' | translate"></th>
          <td [id]="'id_pre_gen_data_' + (i+1)" mat-cell *matCellDef="let element; let i = index"> 
            <span *ngIf="element?.has_pre_generated === 0; else showQty">-</span>
            <ng-template #showQty>{{element?.pre_generated_qty}} / {{element?.pre_generated_max_qty}}</ng-template>
          </td>
        </ng-container>
 
        <!-- On Demand Quantity -->
        <ng-container matColumnDef="on_demand">
          <th id="id_on_dmnd_header" mat-header-cell *matHeaderCellDef [innerHtml]="'TBL_HDR_ON_DEMAND' | translate"></th>
          <td [id]="'id_on_dmnd_data_' + (i+1)" mat-cell *matCellDef="let element; let i = index"> 
            <span *ngIf="element?.has_on_demand === 0; else showQty">-</span>
            <ng-template #showQty>{{element?.on_demand_qty}}</ng-template>
          </td>
        </ng-container>
 
        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" [class.selected]="row?.distribution_id == selectedRow?.distribution_id" (click)="openWizard(null, 'view', row)"></tr>
      </table>
    </div>
  </div>
 
  <div *ngIf="!loading.error && !loading.init && !listData?.length" fxFlex fxLayout="column" fxLayoutAlign="center center">
    <mat-icon color="primary" svgIcon="information-outline" class="size-48"></mat-icon>
    <span class="mat-body" [class.compact-header-text]="media.isActive('lt-sm')">
      {{ 'LABEL_NO_DATA' | translate}}
    </span>
  </div>
 
  <div *ngIf="loading.error && !loading.init && !listData?.length" fxLayoutGap="20px" fxFlex fxLayout="column"
    fxLayoutAlign="center center">
    <mat-icon color="warn" svgIcon="alert-circle-outline" class="size-48"></mat-icon>
    <span class="mat-body">
      {{ 'MSG_ERROR_NETWORK_CONNECTION' | translate }}
    </span>
    <button color="primary" mat-raised-button (click)="refresh()">
      {{ 'LABEL_RETRY' | translate }}  
    </button>
  </div>
  
  <div *ngIf="loading.init || loading.more || loading.export" fxFlex fxLayout="column" fxLayoutAlign="center center" class="loading-indicator-report">
    <mat-spinner></mat-spinner>
  </div>
  
</div>